import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss']
})
export class HelpButtonComponent {
  @Input() title;
  @Input() msg;
  @Input() small = false;
  @Input() modalId = 'helpModal';
  constructor() { }
}
